module.exports = __webpack_public_path__ + "img/20191205172010360截图20191205170806739.ab0cd9a5.jpg";